import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import useHourlyContainer from "./useHourlyContainer";
import TabChartFilter from "../components/TabChartFilter";
// import { useGetEnumsValue } from "../../../scenes/OrganizationDefinitions/CreateUserAccount/Hooks";
// import { enumsRender } from "../../../scenes/OrganizationDefinitions/CreateUserAccount/StaticFiles";
import { useGetEnumsValue } from "../../../OrganizationDefinitions/CreateUserAccount/Hooks";
import { enumsRender } from "../../../OrganizationDefinitions/CreateUserAccount/StaticFiles";
import Tabs from "./Tabs/ProductionStepTabs";
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

import {
  Box,
  Typography,
  Autocomplete,
  TextField,
  Paper,
  Grid,
  Button,
  useTheme,
  Fade,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import {
  CartesianGrid,
  Line,
  Bar,
  BarChart,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  Legend,
} from "recharts";
import useDeviceType from "../../../global/Hooks/useDeviceType";
import RenderDatePicker from "../components/RenderDatePicker";
import TitleChart from "../components/TitleChart";
import useCheckDisplayChart from "../components/useCheckDisplayChart";
import { FilterIcon } from "lucide-react";
import FilterHandler from "../components/FilterHandler";

function ProductionStepChart() {
  const theme = useTheme().palette.mode;

  const { action, value } = useHourlyContainer();

  const deviceType = useDeviceType();
  const [open, setOpen] = useState(false);
  const { data: enumsData, isFetched } = useGetEnumsValue(["ProcessStepPoint"]);
  const ProcessStepPoints = enumsRender(enumsData, "ProcessStepPoint");
  // const [activeFilterType, setActiveFilterType] = useState(1);

  const [processStepPoint, setProcessStepPoint] = useState({
    key: "ثبت سفارش",
    value: 1,
  });

  /* -------------------------------- Accrdion -------------------------------- */
  const chartKey = "orderHourChart";
  const { displayChart } = useCheckDisplayChart(chartKey);
  const [filter, setFilter] = useState(false);
  const [processStepValue, setProcessStepValue] = useState(""); // just 1, 2, 3 etc.

  const toPersianDigits = (str) => {
    if (!str) return "";
    return str.toString().replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);
  };

  const renderChart = () => {
    if (value?.activeFilterType === 1) {
      return (
        <ResponsiveContainer width="100%" minHeight={"18rem"}>
          <LineChart
            width={"auto"}
            height={"17.5rem"}
            data={value?.registerCountData?.data?.data?.items}
            margin={{
              top: 5,
              right: 5,
              left: deviceType === "mobile" ? -10 : 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="name"
              fontSize={"10px"}
              angle={0}
              tickMargin={5}
              // اعمال فرمتر برای اعداد محور X
              tickFormatter={(value) => toPersianDigits(value)}
            />
            <YAxis
              fontSize={deviceType === "mobile" ? "11px" : "14px"}
              tickMargin={deviceType === "mobile" ? 30 : 50}
              // اعمال فرمتر برای اعداد محور Y
              tickFormatter={(value) => toPersianDigits(value)}
            />
            <Tooltip
              content={({ active, payload, label }) => {
                if (active && payload && payload.length) {
                  return (
                    <div
                      style={{
                        background: "#fff",
                        color: "#1E6AFD",
                        padding: "10px",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                      }}
                    >
                      {payload.map((entry, i) => (
                        <div key={i}>
                          {entry.name} :{toPersianDigits(entry.value)}
                        </div>
                      ))}
                    </div>
                  );
                }
                return null;
              }}
            />
            {/* <Tooltip
              content={({ value }) => {
                return (
                  <div
                    style={{
                      background: "#fff",
                      padding: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                    }}
                  >
                    {salseExperts?.map((item, i) => {
                      const strokeColor = colors[i] ?? defaultColor;
                      const key = i === 0 ? "value" : `value${i}`;
                      return (
                        <Typography fontSize={14} color={strokeColor}>
                          {item} :
                          {i === 0
                            ? persianDigitWithSeprator(data.value)
                            : persianDigitWithSeprator(data[key])}
                        </Typography>
                      );
                    })}
                  </div>
                );

                return null;
              }}
            /> */}
            <Line
              type="monotone"
              name=" سفارشات ثبت شده"
              dataKey="value"
              stroke="#3592FB"
              activeDot={{ r: 8 }}
            />
          </LineChart>
        </ResponsiveContainer>
      );
    } else {
      return (
        <ResponsiveContainer width="100%" minHeight="22rem">
          <BarChart
            width={800}
            height={"100%"}
            data={value?.OperatorStepsData?.data?.data?.items}
            style={{ fontSize: "11px" }}
            barSize={30}
            angle={0}
            textAnchor="end"
            margin={{
              top: 2,
              right: 0,
              left: deviceType === "mobile" ? -40 : -20,
              bottom: 10,
            }}
          >
            <CartesianGrid strokeDasharray="3 2" />
            <XAxis
              dataKey="name"
              angle={-30}
              tickMargin={12}
              tickFormatter={(name) =>
                name.length > 12 ? `${name.slice(0, 12)}...` : name
              }
            />
            <YAxis
              tickMargin={deviceType === "mobile" ? 10 : 30}
              fontSize={deviceType === "mobile" ? "11px" : "13px"}
              // اعمال فرمتر برای اعداد محور Y
              tickFormatter={(value) => toPersianDigits(value)}
            />
            <YAxis
              yAxisId="right" // اضافه کردن یک YAxis دیگر برای اطمینان از پوشش تمام فرمت‌ها
              orientation="right"
              tickMargin={deviceType === "mobile" ? 10 : 30}
              fontSize={deviceType === "mobile" ? "11px" : "13px"}
              // اعمال فرمتر برای اعداد محور Y سمت راست
              tickFormatter={(value) => toPersianDigits(value)}
            />
            <Tooltip
              cursor={false}
              content={({ active, payload, label }) => {
                if (active && payload && payload.length) {
                  const data = payload[0].payload;
                  return (
                    <div
                      style={{
                        background: "#e7d9d9ff",
                        padding: "10px",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                      }}
                    >
                      <Typography
                        variant={"caption"}
                        className="font-num"
                        color={"#3592FB"}
                      >{`تعداد: ${toPersianDigits(data.value)}`}</Typography>{" "}
                      {/* استفاده از فرمتر در اینجا */}
                    </div>
                  );
                }
                return null;
              }}
            />

            <Bar
              dataKey="value"
              name={"  سفارشات "}
              stackId="a"
              fill="#3592FB"
            />
          </BarChart>
        </ResponsiveContainer>
      );
    }
  };

  return (
    <Layout>
      {displayChart ? (
        <>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: 2,
              marginBottom: "4px",
              flexWrap: "nowrap",
              overflowX: "auto",
            }}
          >
            <Box
              sx={{
                display: "flex",
                width: "100%",
                padding: "0.5rem",
                flexWrap: "wrap",
              }}
            >
              <Tabs
                activeFilterType={value?.activeFilterType}
                setActiveFilterType={action?.setActiveFilterType}
              />
            </Box>
            <Box
              sx={{
                flexGrow: 1,
                width: "40%",
                display: "flex",
                justifyContent: "flex-start",
                minWidth: 200,
              }}
            >
              <TitleChart label={"مراحل تولید"} chartKey={chartKey} />
            </Box>
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginLeft: "auto",
                  marginRight: "8px",
                }}
              >
                <TabChartFilter
                  chartFilter={value.chartFilter}
                  tabHandler={action.tabHandler}
                  name={"Production"}
                />
              </Box>
              <FilterHandler filter={filter} setFilter={setFilter} />
            </Box>
          </Box>
          <Grid container>
            {filter && (
              <Fade in={filter} timeout={300}>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      padding: "8px",
                      backgroundColor: theme == "light" ? "#E6F1FF" : "#161B25",
                    }}
                  >
                    <RenderDatePicker
                      chartFilter={value.chartFilter}
                      datePicker={value.datePicker}
                      setDatePicker={action.setDatePicker}
                    />

                    <Box sx={{ width: "200px", marginLeft: "8px" }}>
                      <FormControl fullWidth size="small">
                        <InputLabel id="process-step-label">مرحله</InputLabel>

                        <Select
                          labelId="process-step-label"
                          value={processStepValue}
                          label="مرحله"
                          onChange={(e) => {
                            const selectedItem = ProcessStepPoints.find(
                              (item) => item.value === e.target.value,
                            );
                            setProcessStepValue(e.target.value);
                            action.setProcessStepPoint(selectedItem);
                          }}
                          renderValue={(value) => {
                            // dynamically show the label
                            const selected = ProcessStepPoints?.find(
                              (item) => item.value === value,
                            );
                            return selected ? selected.key : "";
                          }}
                          sx={{ fontSize: "12px" }}
                        >
                          {ProcessStepPoints?.map((item) => (
                            <MenuItem key={item.value} value={item.value}>
                              {item.key}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  </Box>
                </Grid>
              </Fade>
            )}

            <Grid item xs={12}>
              {renderChart()}
            </Grid>
          </Grid>
        </>
      ) : (
        <Box
          sx={{
            flexGrow: 1,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            minWidth: 200,
          }}
        >
          <TitleChart label={"مراحل تولید"} chartKey={chartKey} />
        </Box>
      )}
    </Layout>
  );
}

export default ProductionStepChart;
